/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper2", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  let prods = window.product;
  $(".selectl span").click(function () {
    $(this).addClass("on").siblings().removeClass("on");
    let index = $(this).index();
    const imgWrap = $(this).closest(".content").siblings(".img-wrap");
    imgWrap.find(".p-img").hide().eq(index).show();

    let id = $(this).attr('data-id');
    let price = prods.filter(item=> item.id == id)[0].price / 100;
    let compare = prods.filter(item=> item.id == id)[0].compare_at_price / 100;
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    $(this).parent().siblings(".price-group").find('.price1 span').html(price);
    $(this).parent().siblings(".price-group").find('.price2 span').html(compare);
  });

  $('.sp-btn-style').click(function(){
    let id = $(this).siblings('.selectl').find('span.on').attr('data-id')
    window.location.href = '/cart/' + id + ':1'
  })
  
  // let spprev = document.querySelector(".sp-swiper-btn-prev");
  // let spnext = document.querySelector(".sp-swiper-btn-next");
  // spnext.addEventListener("click", function () {
  //   let items = document.querySelectorAll(".sp-swiper-item");
  //   document.querySelector(".sp-swiper-box").appendChild(items[0]);
  // });
  // spprev.addEventListener("click", function () {
  //   let items = document.querySelectorAll(".sp-swiper-item");
  //   document.querySelector(".sp-swiper-box").prepend(items[items.length - 1]);
  // });
  
  // // 支持手指/鼠标滑动切换
  // (function () {
  //   const swiperBox = document.querySelector('.sp-swiper-box');
  //   if (!swiperBox) return;
  //   let startX = 0;
  //   let isTouch = false;
  //   let threshold = 50; // 滑动阈值

  //   // 触摸事件
  //   swiperBox.addEventListener('touchstart', function(e) {
  //     if (e.touches.length === 1) {
  //       isTouch = true;
  //       startX = e.touches[0].clientX;
  //     }
  //   });
  //   swiperBox.addEventListener('touchmove', function(e) {
  //     // 阻止页面滚动
  //     if (isTouch) e.preventDefault();
  //   }, { passive: false });
  //   swiperBox.addEventListener('touchend', function(e) {
  //     if (!isTouch) return;
  //     let endX = e.changedTouches[0].clientX;
  //     let diff = endX - startX;
  //     if (diff > threshold) {
  //       // 向右滑，上一项
  //       spprev.click();
  //     } else if (diff < -threshold) {
  //       // 向左滑，下一项
  //       spnext.click();
  //     }
  //     isTouch = false;
  //   });

  //   // 鼠标事件（PC端）
  //   let mouseDown = false;
  //   let mouseStartX = 0;
  //   swiperBox.addEventListener('mousedown', function(e) {
  //     mouseDown = true;
  //     mouseStartX = e.clientX;
  //   });
  //   swiperBox.addEventListener('mousemove', function(e) {
  //     if (mouseDown) e.preventDefault();
  //   });
  //   swiperBox.addEventListener('mouseup', function(e) {
  //     if (!mouseDown) return;
  //     let mouseEndX = e.clientX;
  //     let diff = mouseEndX - mouseStartX;
  //     if (diff > threshold) {
  //       spprev.click();
  //     } else if (diff < -threshold) {
  //       spnext.click();
  //     }
  //     mouseDown = false;
  //   });
  //   // 鼠标离开区域时取消
  //   swiperBox.addEventListener('mouseleave', function(e) {
  //     mouseDown = false;
  //   });
  // })();
  
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");

      let scale = document.body.clientWidth / 1080;
       if (scale > 1) scale = 1
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              let scale = document.body.clientWidth / 1080;
               if (scale > 1) scale = 1
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    let imgArr = [
      'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250704-p1.png',
      'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250704-p1-1.png',
      'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250704-p2.png',
      'https://cdn.shopify.com/s/files/1/0635/2712/5141/files/20250704-p2-1.png',
    ]
    preloadImages(imgArr)
    
    lazyLoadImages();

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
});
